// import archiveIcon from '../../assets/personal/archiveIcon.jpg';
import p1 from '../../assets/personal/1.jpg';
import p2 from '../../assets/personal/2.jpg';
import p3 from '../../assets/personal/3.jpg';
import p4 from '../../assets/personal/4.jpg';
import p5 from '../../assets/personal/5.jpg';
import p6 from '../../assets/personal/6.jpg';
import p7 from '../../assets/personal/7.jpg';
import p8 from '../../assets/personal/8.jpg';
import p9 from '../../assets/personal/9.jpg';
import p10 from '../../assets/personal/10.jpg';
import p11 from '../../assets/personal/11.jpg';
import p12 from '../../assets/personal/12.jpg';
import p13 from '../../assets/personal/13.jpg';
import p14 from '../../assets/personal/14.jpg';
import p15 from '../../assets/personal/15.jpg';
import p16 from '../../assets/personal/16.jpg';
import p18 from '../../assets/personal/18.jpg';
import p19 from '../../assets/personal/19.jpg';
import p20 from '../../assets/personal/20.jpg';
import p21 from '../../assets/personal/21.jpg';
import p22 from '../../assets/personal/22.jpg';
import p23 from '../../assets/personal/23.jpg';
import p24 from '../../assets/personal/24.jpg';
import p25 from '../../assets/personal/25.jpg';
import p26 from '../../assets/personal/26.jpg';
import p27 from '../../assets/personal/27.jpg';
import p28 from '../../assets/personal/28.jpg';
import p29 from '../../assets/personal/29.jpg';
import p30 from '../../assets/personal/30.jpg';
import p31 from '../../assets/personal/31.jpg';
import p32 from '../../assets/personal/32.jpg';
import p33 from '../../assets/personal/33.jpg';
import p34 from '../../assets/personal/34.jpg';
import p35 from '../../assets/personal/35.jpg';
import p36 from '../../assets/personal/36.jpg';
import p37 from '../../assets/personal/37.jpg';
import p38 from '../../assets/personal/38.jpg';
import p39 from '../../assets/personal/39.jpg';
import p40 from '../../assets/personal/40.jpg';
import p41 from '../../assets/personal/41.jpg';
import p42 from '../../assets/personal/42.jpg';
import p43 from '../../assets/personal/43.jpg';
import p44 from '../../assets/personal/44.jpg';
import p45 from '../../assets/personal/45.jpg';
import p46 from '../../assets/personal/46.jpg';


const availableImg = [p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12, p13, p14, p15, p16, p18, p19, p20, p21, p22, p23, p24, p25, p26, p27, p28, p29, p30, p31, p32, p33, p34, p35, p36, p37, p38, p39, p40, p41, p42, p43, p44, p45, p46];


export default availableImg;